import { DEFAULT_MENU_THEME } from "../../../config/menuThemes";
import ClassicCartTheme from "./ClassicCartTheme";
import GardenFreshCartTheme from "./GardenFreshCartTheme";
import JapaneseMinimalCartTheme from "./JapaneseMinimalCartTheme";
import BrewBitesCartTheme from "./BrewBitesCartTheme";
import NovaCartTheme from "./NovaCartTheme";
import MizbanSignatureCartTheme from "./MizbanSignatureCartTheme";
import LuxuryWhiteCartTheme from "./LuxuryWhiteCartTheme";
import StreetFoodCartTheme from "./StreetFoodCartTheme";
import RoyalGoldCartTheme from "./RoyalGoldCartTheme";
import PersianHeritageCartTheme from "./PersianHeritageCartTheme";

const cartThemeRegistry = {
  classic: ClassicCartTheme,
  gardenFresh: GardenFreshCartTheme,
  japaneseMinimal: JapaneseMinimalCartTheme,
  brewBites: BrewBitesCartTheme,
  nova: NovaCartTheme,
  mizbanSignature: MizbanSignatureCartTheme,
  luxuryWhite: LuxuryWhiteCartTheme,
  streetFood: StreetFoodCartTheme,
  royalGold: RoyalGoldCartTheme,
  persianHeritage: PersianHeritageCartTheme,
};

export const getCartThemeComponent = (theme) => (
  cartThemeRegistry[theme] || cartThemeRegistry[DEFAULT_MENU_THEME]
);

export default cartThemeRegistry;
